<template>
  <NuxtLayout>
    <h1 class="aboutUs__Title" v-text="page.title" />

    <FlarePicture :src="{
        1920: { src: page.image, width: 1920, height: 960, size: 'both', crop: 'fill', requestLarger: false },
        1440: { src: page.image, width: 1440, height: 720, size: 'both', crop: 'fill', requestLarger: false },
        1024: { src: page.image, width: 1024, height: 512, size: 'both', crop: 'fill', requestLarger: false },
      }"
      class="aboutUs__HeaderImage"
      :alt="page.image?.alt"
      :lazy="false"
      fetchPriority="high"
    />

    <CMSField v-if="page?.content" :data="page.content" />
  </NuxtLayout>
</template>

<script setup>
  defineOptions({
    auth: 'aminess'
  });
  
  defineProps({
    page: {}
  });
</script>

<style lang="scss">
  @import url('@/assets/styles/pages/_aboutUs.scss');
</style>